import React, { FC } from 'react';
import moment from 'moment';

import colors from '../../../../assets/colors';
import { Typography } from '../../../../shared/typography';
import RoundImg from '../../../../shared/avatar';

const size = 32;

export const Message: FC<any> = ({ item, mine }) => {
	const { content, createdAt, name, avatar } = item;

	const renderAvatar = () => (
		<div
			style={{
				display: 'flex',
				borderRadius: size / 2,
				marginRight: size / 3,
				backgroundColor: colors.lightGrey,
				width: size,
				height: size,
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<RoundImg avatar={avatar} size={size} name={name} />
		</div>
	);

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: mine ? 'flex-end' : 'flex-start',
				alignItems: 'flex-end',
				marginBottom: 12,
			}}
		>
			{!mine ? renderAvatar() : null}
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					position: 'relative',
					backgroundColor: mine ? colors.green : colors.lightGrey,
					padding: '8px 70px 8px 16px',
					borderRadius: 20,
					borderBottomLeftRadius: mine ? 20 : 0,
					borderBottomRightRadius: mine ? 0 : 20,
					maxWidth: '70%',
				}}
			>
				{!mine && (
					<Typography color="orange" size="normal">
						{name}
					</Typography>
				)}
				<Typography
					color={mine ? 'white' : 'black'}
					type="primary"
					size="medium"
				>
					{content}
				</Typography>
				<div style={{ position: 'absolute', right: 13, bottom: 8, width: 40 }}>
					<Typography
						color={mine ? 'lightGrey' : 'btnTextGrey'}
						size="normal"
						style={{ textAlign: 'right' }}
					>
						{moment(createdAt).format('hh:mm')}
					</Typography>
				</div>
			</div>
		</div>
	);
};
